<template>
  <v-snackbar
    v-model="message.show"
    :color="message.color"
    :timeout="-1"
    :location="message.location"
    @update:model-value="(v) => !v && store.dismiss()"
  >
    {{ message.text }}
    <template v-if="message.actionRoute" #actions>
      <v-btn
        variant="text"
        size="small"
        :to="message.actionRoute"
        @click="store.dismiss()"
      >
        {{ message.actionText }}
      </v-btn>
    </template>
    <template v-else #actions>
      <v-btn variant="text" size="small" @click="store.dismiss()">
        {{ t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useSnackbarStore } from '@/stores/snackbar'
import { useI18n } from 'vue-i18n'

const store = useSnackbarStore()
const { message } = storeToRefs(store)
const { t } = useI18n()
</script>
